import { Entrepot } from '../../models/entrepot';
import { EntrepotFormPayload } from '../logiciel-caisse/logiciel-caisse-entrepot.service';

/** Payload POST {stock_url}/api/entrepots à partir du formulaire entrepôt caisse. */
export function buildErpEntrepotPayloadFromLcForm(
  body: EntrepotFormPayload,
  erpUserId: number,
  erpStationId: number
): Entrepot {
  const nom = String(body.libelle ?? '').trim() || 'Entrepôt';
  const ville = String(body.ville ?? 'N/A').trim() || 'N/A';
  const pays = String(body.pays ?? 'Tunisie').trim() || 'Tunisie';
  const codeRaw = body.code_entrepot != null ? String(body.code_entrepot).trim() : '';
  const code =
    codeRaw && codeRaw !== '—'
      ? codeRaw
      : `LC-${nom.replace(/\s+/g, '-').slice(0, 40)}`.toUpperCase();
  return {
    station_id: erpStationId,
    user_id: erpUserId,
    nom,
    code,
    adresse: [nom, ville, pays].filter(Boolean).join(', '),
    ville,
    code_postal: '0000',
    pays,
  };
}
